import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'wen-icon-terminated',
  templateUrl: './terminated.component.html',
  styleUrls: ['./terminated.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TerminatedIconComponent {}
